/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomModelDefinition.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "common/custom-model-definition";

export class AutogenModelCustomModelDefinition<RowType extends ModelRow> extends Endpoint<RowType, RowCustomModelDefinitionFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowCustomModelDefinition extends ModelRow<RowCustomModelDefinitionFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowCustomModelDefinitionFields {
    company_id: string;
    definition: string;
    id: string;
}

